import { decimal, money, taxRate } from '@/js/shared/billables/decimal';
import { documentShippingAmount } from '@/js/shared/billables/document_shipping';

export function calculatePurchaseOrderTotals({ items, tax, shipping, documentShipping, payments }) {
  const subtotal = money(items.reduce((sum, item) => sum.plus(money(item.total)), decimal(0)));
  const shippingAmount = documentShippingAmount(subtotal, documentShipping) ?? money(shipping || 0);
  const taxAmount = calculateTaxAmount(subtotal, shippingAmount, tax);
  const total = subtotal.plus(taxAmount).plus(shippingAmount).round(2);

  return {
    subtotal: subtotal.toFixed(2),
    tax: taxAmount.toFixed(2),
    shipping: shippingAmount.toFixed(2),
    total: total.toFixed(2),
    balance: total
      .minus(money(payments || 0))
      .round(2)
      .toFixed(2),
  };
}

function calculateTaxAmount(subtotal, shipping, tax) {
  const rate = taxRate(tax.rate);
  let amount = subtotal.times(rate).div('100');

  if (tax.taxShipping) {
    amount = amount.plus(shipping.times(rate).div('100'));
  }

  return amount.round(2);
}
